// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2JCg-","vLegacy":"SelectSecondary_vLegacy__2h1r4","error":"SelectSecondary_error__C4WwY","disabled":"SelectSecondary_disabled__NQm2r"};